import PercentageItem from '@op/components/Snippets/PercentageItem';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import React, { useMemo } from 'react';
import './index.scss';
import { DBO_V } from '@op/utils/format';
import moment from 'moment';
import useLanguage from '@op/hooks/useLanguage';

export const METRICS_LIST: MetricItemType[] = [
  {
    name: 'Potential Impressions',
    value: 'potential_exposure_all',
    key: 'followers',
  },
  {
    name: 'Publication',
    value: 'total_posts_all',
    key: 'posts',
  },
  {
    name: 'Number of Creators',
    value: 'total_reviews_all',
    key: 'reviews',
    hasLanguage: false
  },
  {
    name: '% of UGC Content',
    value: 'ugc_content_proportion_official',
    key: 'ugc_posts',
    format: (value: any) => DBO_V.percentageFormat(value * 100),
    isPercentage: true,
  },
  {
    name: '% of Official Content',
    value: 'content_proportion_official',
    key: 'account_posts',
    format: (value: any) => DBO_V.percentageFormat(value * 100),
    isPercentage: true,
  }, 
  {
    name: 'Official Engagement',
    value: 'total_engagement_official',
    key: 'account_engagements',
  },
  {
    name: 'Official Potential Impressions',
    value: 'potential_exposure_official',
    key: 'account_followers',
  },
  {
    name: 'Official Engagement Rate',
    value: 'interaction_rate_official',
    key: 'account_interaction_rate',
    format: (value: any) => DBO_V.percentageFormat(value * 100),
    isPercentage: true,
  },
];

export type MetricItemType = {
  name: string;
  value: string;
  key: string;
  format?: (value: any) => string | number;
  isPercentage?: boolean;
  hasLanguage?:boolean;
};

export default function LeftMetrics({
  selectMetric,
  serSelectMetric,
  data,
}: {
  serSelectMetric: any;
  selectMetric: any;
  data: any;
}) {
  const { formatMessage } = useLanguage();
  const { timeObj, newData, oldData } = useMemo(() => {
    const { new: newData, old: oldData } = data || {};

    function getTimeList(data: any) {
      const { start_time, end_time } = data || {};
      return [start_time, end_time];
    }

    return {
      timeObj: {
        newTime: getTimeList(newData),
        oldTime: getTimeList(oldData),
      },
      newData: newData || {},
      oldData: oldData || {},
    };
  }, [data]);

  return (
    <div className="dbo-left-metrics-card">
      {METRICS_LIST.map(
        ({ format = (value: any) => DBO_V.reviews(value), ...item }) => (
          <div
            key={item.name}
            onClick={() => serSelectMetric({ ...item, format })}
            className={`dbo-left-metrics-item ${
              selectMetric.name === item.name && '--dbo-active'
            }`}
          >
            <div className="dbo-left-metrics-title">
              {formatMessage(item.name)}
            </div>
            <div className="dbo-left-metrics-data">
              <div className="dbo-left-metrics-data-quantity">
                {format?.(newData[item.value])}
              </div>
              <RingRatioBubble
                title={`${formatMessage(item.name)} ${formatMessage(
                  'Change Rate',
                )}`}
                {...timeObj}
                oldValue={oldData[item.value]}
                newValue={newData[item.value]}
                placement="top"
                formateValue={format}
                formateDate={(value) => moment(value).format('YYYY-MM-DD')}
              >
                <PercentageItem
                  percentage={DBO_V.qoq(
                    newData[item.value],
                    oldData[item.value],
                  )}
                ></PercentageItem>
              </RingRatioBubble>
            </div>
          </div>
        ),
      )}
    </div>
  );
}
